import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { debounceTime, of, Subscription, switchMap, tap } from 'rxjs';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';
import { CalendarService } from 'src/app/services/calendar.service';
import { FormGroup } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
	selector: 'calendar-group-selector',
	templateUrl: './calendar-group-selector.component.html',
})
export class CalendarGroupSelectorComponent implements OnInit, OnDestroy {


	subscriptions = new Subscription();

	myInputs: DataInput[] = [];
	formG1 = new FormGroup({});
	userSuscribable: { [key:string]: boolean } = {};

	@Input() userId = this.authenticationService.getCurrentUser().ebeId;
	@Output() newCalendarGroupsSelection = new EventEmitter<string[]>();


	constructor(
		private calendarService: CalendarService,
		private authenticationService: AuthenticationService,
		private matSnackBar: MatSnackBar
	) {}


	ngOnInit() {

		this.calendarService.getCalendarGroups().pipe(
			switchMap( calendarGroups => {

				for( const calendarGroup of calendarGroups ) {
					this.userSuscribable[ calendarGroup.vgId ] = !calendarGroup.arbeitsgruppe;
				}

				return ( this.userId
					? this.calendarService.getCalendarGroupsSubscribedToUser( this.userId )
					: of( [] as string[] )
				).pipe(
					tap( userCalendarGroups => {

						const bAdmin = this.authenticationService.isAdmin();
						const activeCalendarGroups = calendarGroups
							.filter( cg => cg.vgAktiv )
						//	.filter( cg => bAdmin || !cg.arbeitsgruppe || userCalendarGroups.includes( cg.vgId ) )
							.sort( (a,b) => a.vgName.localeCompare( b.vgName ) );

						const diValues: { [key: string]: boolean } = {};

						for( const calendarGroup of activeCalendarGroups ) {

							const di = new DataInput();
							di.id = "" + calendarGroup.vgId;
							di.type = "check";
							di.label = calendarGroup.vgName;
							di.disabled = !bAdmin && calendarGroup.arbeitsgruppe;
							di.defaultValue = userCalendarGroups.includes( calendarGroup.vgId );
							this.myInputs.push( di );

							diValues[ calendarGroup.vgId ] = userCalendarGroups.includes( calendarGroup.vgId );

						}

						setTimeout( () => {

							this.formG1.patchValue( diValues, { emitEvent: false } );

							this.subscriptions.add(
								this.formG1.valueChanges.pipe(
									debounceTime( 400 ),
									switchMap( ( values: { [key: string]: boolean } ) => {

										const groupIds: string[] = [];
										for( let ctrlName in values ) {
											if( values[ctrlName] ) {
												groupIds.push( ctrlName );
											}
										}

										// if user is not admin, add manually group ids for which the user is forcibly subscribed
										for( const myInput of this.myInputs ) {
											if( myInput.disabled ) {
												const cg = calendarGroups.find( g => g.vgId == myInput.id );
												if( cg && cg.arbeitsgruppe ) groupIds.push( cg.vgId );
											}
										}

										return this.userId
											? this.calendarService.subscribeUserToCalendarGroups( this.userId, groupIds ).pipe(
												tap( b => {
													if( b ) this.matSnackBar.open( 'Erfolgreiche Speicherung', 'Speichern' );
													else	this.matSnackBar.open( 'Fehlgeschlagene Speicherung', 'Speichern' );
												})
											)
											: of(true).pipe(
												tap( _ => this.newCalendarGroupsSelection.emit( groupIds ) )
											);

									})
								).subscribe()
							);

						}, 1 );

					} )
				);

			})
		).subscribe();

	}

	ngOnDestroy() {

		this.subscriptions.unsubscribe();

	}


}

